import React, { useEffect } from "react";
import useMethodAccount from "./hooks/useMethodAccount";
import "./style.scss";
import LimitedTicket from "./limitedTicket";
import { HiOutlineTicket } from "react-icons/hi";
import { BiCommentError } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import FutureTickets from "./FutureTickets";

const AccountTickets: React.FC = () => {
  const { passes, getLimited, getSelect } = useMethodAccount();
  const { t } = useTranslation();

  useEffect(() => {
    getLimited();
    getSelect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="account-tickets">
        <h5 className="ticket-title flex-start-center">
          <HiOutlineTicket className="icon" />
          {t("bilety_na_wybrany_dzien")}
        </h5>

        <div className="flex-start flex-wrap">
          <FutureTickets />
        </div>

        <h5 className="ticket-title flex-start-center">
          <HiOutlineTicket className="icon" />
          {t("bilety_wazne_okreslony_czas")}
        </h5>

        <div className="flex-start flex-wrap">
          {passes.length > 0 ? (
            <>
              {passes.map((ticket, index) => (
                <div key={index} className="single-ticket-limited">
                  <LimitedTicket ticket={ticket} />
                </div>
              ))}
            </>
          ) : (
            <>
              <div className="alert alert-yellow">
                <BiCommentError className="alert-icon" />
                <b>{t("brak_biletow")}</b>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AccountTickets;
